import axios from 'axios';
import { API_URL } from './config';
import { LocalStorageKey } from 'utils/common/const';

const BEARER = 'Bearer ';
const baseConfig = {
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json'
  }
};

export const instanceBase = axios.create({
  baseURL: API_URL,
  ...baseConfig
});

let hasHandledUnauthorized = false;

// Add a request interceptor
instanceBase.interceptors.request.use(
  function (config) {
    const accessToken = localStorage.getItem(LocalStorageKey.ACCESS_TOKEN);
    if (accessToken) {
      config.headers.Authorization = `${BEARER}${accessToken}`;
    }
    return config;
  },
  function (error) {
    console.log('Request error: ' + error);
    return Promise.reject(error);
  }
);

// Add a response interceptor
instanceBase.interceptors.response.use(
  function (response) {
    const data = response?.data ? response.data : response;

    const code = data?.code;
    if ((code === 401 || code === '401') && !hasHandledUnauthorized && typeof window !== 'undefined') {
      hasHandledUnauthorized = true;
      try {
        localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
        localStorage.removeItem(LocalStorageKey.REFRESH_TOKEN);
        localStorage.removeItem(LocalStorageKey.USER_INFO);
        localStorage.removeItem('ok9_username');
      } catch {
        // ignore
      }

      try {
        delete instanceBase.defaults.headers.common.Authorization;
      } catch {
        // ignore
      }

      window.location.reload();
    }

    return data;
  },
  async function (error) {
    console.log('Response error: ' + error.message);

    const status = error?.response?.status;
    if (status === 401 && !hasHandledUnauthorized && typeof window !== 'undefined') {
      hasHandledUnauthorized = true;
      try {
        localStorage.removeItem(LocalStorageKey.ACCESS_TOKEN);
        localStorage.removeItem(LocalStorageKey.REFRESH_TOKEN);
        localStorage.removeItem(LocalStorageKey.USER_INFO);
        localStorage.removeItem('ok9_username');
      } catch {
        // ignore
      }

      try {
        delete instanceBase.defaults.headers.common.Authorization;
      } catch {
        // ignore
      }

      // Reload current page (OK9Page) after clearing session
      window.location.reload();
    }

    return Promise.reject(error);
  }
);

class APIBase {
  get = async (url, data, config) => {
    return instanceBase.get(url, data, { ...config });
  };

  post = (url, data, config) => {
    return instanceBase.post(url, data, { ...config });
  };

  put = (url, data, config) => {
    return instanceBase.put(url, data, { ...config });
  };

  delete = (url, config) => {
    return instanceBase.delete(url, { ...config });
  };
}

const setAuthorizationBase = (token) => {
  // Remove double quotes from the token, if they exist
  token = token.replace(/"/g, '');
  instanceBase.defaults.headers.common['Authorization'] = `${BEARER} ${token}`;
};

export { APIBase, setAuthorizationBase };
